import { createSlice } from '@reduxjs/toolkit'
import {
  addDelai,
  deleteDelai,
  getDelaibyId,
  getDelaisByActionId,
  updateDelai,
} from './delaisActions'
import { Delai, DelaiResponse } from '../../types/delaisTypes'

interface DelaiState {
  delais: Delai[]
  loading: boolean
  delai: Delai | null
  error: string | null
  addedDelai: Delai | null
  updatedDelai: Delai | null
  DelaiResponse: DelaiResponse | null
}

const initialState: DelaiState = {
  delais: [],
  loading: false,
  error: null,
  addedDelai: null,
  delai: null,
  updatedDelai: null,
  DelaiResponse: null,
}

export const delaiSlice = createSlice({
  name: 'delai',
  initialState,
  reducers: {
    clearDelaiError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteDelai.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(deleteDelai.fulfilled, (state, action) => {
        state.loading = false
        state.error = null
        const deletedDelaiId = action.meta.arg

        if (state.delais) {
          state.delais = (state.delais ?? []).filter(
            (delai) => delai._id !== deletedDelaiId
          )
        }
      })
      .addCase(deleteDelai.rejected, (state, action) => {
        state.loading = false
        state.error =
          (action.payload as string) ||
          action.error.message ||
          'Something went wrong'
      })
      .addCase(addDelai.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(addDelai.fulfilled, (state, action) => {
        state.loading = false
        state.error = null
        state.addedDelai = action.payload
        if (Array.isArray(state.delais)) {
          state.delais.push(action.payload)
        } else {
          state.delais = [action.payload]
        }
      })
      .addCase(addDelai.rejected, (state, action) => {
        state.loading = false
        state.error =
          (action.payload as string) ||
          action.error.message ||
          'Something went wrong'
      })
      .addCase(updateDelai.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateDelai.fulfilled, (state, action) => {
        state.loading = false
        state.error = null
        state.updatedDelai = action.payload
      })
      .addCase(updateDelai.rejected, (state, action) => {
        state.loading = false
        state.error =
          (action.payload as string) ||
          action.error.message ||
          'Something went wrong'
      })
      .addCase(getDelaibyId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getDelaibyId.fulfilled, (state, action) => {
        state.loading = false
        state.delai = action.payload
      })
      .addCase(getDelaibyId.rejected, (state, action) => {
        state.loading = false
        state.error =
          (action.payload as string) ||
          action.error.message ||
          'Something went wrong'
      })
      .addCase(getDelaisByActionId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getDelaisByActionId.fulfilled, (state, action) => {
        state.loading = false
        state.error = null
        const activitiesDelais = Object.values(action.payload).filter(
          (item) => item && typeof item === 'object'
        )
        state.delais = activitiesDelais as []
      })
      .addCase(getDelaisByActionId.rejected, (state, action) => {
        state.loading = false
        state.error =
          (action.payload as string) ||
          action.error.message ||
          'Something went wrong'
      })
  },
})

export const { clearDelaiError } = delaiSlice.actions

export default delaiSlice.reducer
